export const FETCH_ADDRESS_TIME_TRACKING = 'FETCH_ADDRESS_TIME_TRACKING';
export const FETCH_ADDRESS_TIME_TRACKING_SUCCESS = 'FETCH_ADDRESS_TIME_TRACKING_SUCCESS';
export const FETCH_ADDRESS_TIME_TRACKING_FAILURE = 'FETCH_ADDRESS_TIME_TRACKING_FAILURE';
export const FETCH_ADDRESS_TIME_TRACKING_CANCEL = 'FETCH_ADDRESS_TIME_TRACKING_CANCEL';
